import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import React, { useState } from 'react';
import { BodyS, BodySBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import ServiceRow from 'components/ServiceRow/ServiceRow';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/subscriptionTooltipStyle';
import { makeStyles } from '@material-ui/core';
import moment from 'moment';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { serviceType as ServiceType } from 'utils/api/models/topUpAddons/singleSubscription';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISubscriptionTooltipProps {
	target?: string;
	endDate?: string;
	type?: ServiceType;
}

const SubscriptionTooltip = ({ target, endDate, type }: ISubscriptionTooltipProps) => {
	const classes = useStyles();
	const splitted = target?.split(',') || [];
	const [loading, setLoading] = useState<boolean>(true);

	return (
		<CustomTooltip>
			<div className={classes.wrapper}>
				<div>
					<BodyS disableMargin inline color="primary-dark">
						{translate('prepaid.loyalty.set.of.numbers.subscription.ending')}
					</BodyS>
					<BodySBold disableMargin inline color="primary-dark">
						{moment(endDate).format('DD-MM-YYYY')}
					</BodySBold>
				</div>
				<ConditionalRender
					show={!!target && type === ServiceType.SERVICES}
					onTrue={() => (
						<div className={classes.services}>
							<CustomCircularProgress text={''} loading={loading} transparent />
							{splitted.map((id) => (
								<ServiceRow id={id} setLoading={setLoading} key={id} />
							))}
						</div>
					)}
				/>
			</div>
		</CustomTooltip>
	);
};

export default SubscriptionTooltip;
